import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppSelector } from '../../hooks/useAppSelector';
import CustomerInsights from '../../components/CustomerInsights';
import CustomerOrderHistory from '../../components/customerOrderHistory';

const PaymentHistory = ({ isFullscreen = false }) => {
    const navigate = useNavigate();
    const { user, restaurant } = useAppSelector(state => state.auth);
    const restaurantId = restaurant?._id || user?.id;
    const wrapperClasses = isFullscreen
        ? 'min-h-screen bg-stone-100 overflow-x-hidden'
        : 'w-full';

    return (
        <div className={wrapperClasses}>
            <div className="sticky top-0 z-10 bg-white border-b border-stone-200 shadow-sm">
                <div className="px-3 py-1.5 sm:px-4 sm:py-1.5">
                    <div className="flex flex-wrap items-center justify-between gap-1.5">
                        <h2 className="text-base font-bold text-stone-800">Payments</h2>
                        {!isFullscreen && (
                            <button
                                type="button"
                                onClick={() => navigate('/restaurant/payments-fullscreen')}
                                className="inline-flex h-7 w-7 items-center justify-center rounded-md border border-stone-200 bg-white text-stone-600 hover:bg-stone-50 transition-colors"
                                title="Fullscreen"
                                aria-label="Fullscreen"
                            >
                                <span className="text-xs">⤢</span>
                            </button>
                        )}
                    </div>
                </div>
            </div>

            <div className="p-3 sm:p-5 space-y-3">
                <div className="bg-white rounded-xl border border-stone-200 shadow-sm p-3 sm:p-4">
                    <h3 className="text-[11px] font-semibold text-stone-500 uppercase tracking-wide mb-1.5">
                        Customer order history
                    </h3>
                    <CustomerOrderHistory />
                </div>

                <div className="bg-white rounded-xl border border-stone-200 shadow-sm p-3 sm:p-4">
                    <h3 className="text-[11px] font-semibold text-stone-500 uppercase tracking-wide mb-1.5">
                        Customer insights
                    </h3>
                    <CustomerInsights restaurantId={restaurantId} />
                </div>
            </div>
        </div>
    );
};

export default PaymentHistory;
